import React from 'react'

const MyContext = React.createContext({
  id: {},
  updateId: () => {},
})

export default MyContext
